import toast from 'react-hot-toast';

// Helper function to get toast classes by variant
export const getToastClasses = (variant = 'info') => {
  const baseClasses = 'relative flex items-center gap-3 px-4 py-3 rounded-lg shadow-xl shadow-black/20 dark:shadow-black/40 border-l-4 transition-all animate-toast-in min-w-[300px] max-w-[400px]';
  
  const variants = {
    success: {
      container: `${baseClasses} bg-gradient-to-r from-emerald-600 to-green-500 dark:from-emerald-500 dark:to-green-400 !text-white border-emerald-700 dark:border-emerald-300 [&>*]:!text-white`,
      icon: 'text-white',
    },
    error: {
      container: `${baseClasses} bg-gradient-to-r from-red-600 to-rose-500 dark:from-red-500 dark:to-rose-400 !text-white border-red-700 dark:border-red-300 [&>*]:!text-white`,
      icon: 'text-white',
    },
    warning: {
      container: `${baseClasses} bg-gradient-to-r from-amber-500 to-yellow-400 dark:from-amber-400 dark:to-yellow-300 !text-black dark:!text-gray-900 border-amber-600 dark:border-amber-500 font-medium [&>*]:!text-black dark:[&>*]:!text-gray-900`,
      icon: 'text-black dark:text-gray-900',
    },
    info: {
      container: `${baseClasses} bg-gradient-to-r from-blue-600 to-indigo-500 dark:from-blue-500 dark:to-indigo-400 !text-white border-blue-700 dark:border-blue-300 [&>*]:!text-white`,
      icon: 'text-white',
    },
  };

  return variants[variant] || variants.info;
};

export function useToast() {
  const showSuccess = (message) => {
    const classes = getToastClasses('success');
    toast.success(message, {
      duration: 3000,
      position: 'bottom-right',
      className: classes.container,
      iconTheme: {
        primary: '#fff',
        secondary: '#10b981',
      },
      style: {
        background: 'transparent',
        padding: 0,
        boxShadow: 'none',
      },
    });
  };

  const showError = (message) => {
    const classes = getToastClasses('error');
    toast.error(message, {
      duration: 4000,
      position: 'bottom-right',
      className: classes.container,
      iconTheme: {
        primary: '#fff',
        secondary: '#ef4444',
      },
      style: {
        background: 'transparent',
        padding: 0,
        boxShadow: 'none',
      },
    });
  };

  const showWarning = (message) => {
    const classes = getToastClasses('warning');
    toast(message, {
      duration: 3500,
      position: 'bottom-right',
      className: classes.container,
      icon: '⚠️',
      iconTheme: {
        primary: '#000',
        secondary: '#f59e0b',
      },
      style: {
        background: 'transparent',
        padding: 0,
        boxShadow: 'none',
      },
    });
  };

  const showInfo = (message) => {
    const classes = getToastClasses('info');
    toast(message, {
      duration: 3000,
      position: 'bottom-right',
      className: classes.container,
      icon: 'ℹ️',
      iconTheme: {
        primary: '#fff',
        secondary: '#3b82f6',
      },
      style: {
        background: 'transparent',
        padding: 0,
        boxShadow: 'none',
      },
    });
  };

  return { showSuccess, showError, showWarning, showInfo };
}
